import axios from "axios";
import { BASE_URL } from "../../_constants/urlConstants";
import { delay, getUUID } from "../../_utils/generalUtils";
import raiseError from "../raiseError";
import qs from "qs";
import { QMS } from "../../_constants/actionConstants";

const fakeQmsUsers = [
  {
    qmsUserId: 1,
    divisionId: 1,
    userRole: {
      value: 0,
      name: "QMS_USER",
      displayName: "QMS User",
      description: "TT/HQ Staff",
    },
    firstName: "Jane",
    middleInitial: "K",
    lastName: "Doe",
    fullName: "Jane K Doe",
    employeeNo: "s123456",
    email: "",
    phoneNumber: "",
    proDmsUserId: 1,
    proDmsUserUnitId: 1,
    district: 59,
    unitNo: "1234",
  },
  {
    qmsUserId: 2,
    divisionId: 1,
    userRole: {
      value: 1,
      name: "QMS_QMR_AUTHORITY",
      displayName: "QMR Authority",
      description: "Delegated authority of the Quality Management Representative",
    },
    firstName: "John",
    middleInitial: "",
    lastName: "Clark",
    fullName: "John Clark",
    employeeNo: "s123456",
    email: "",
    phoneNumber: "",
    proDmsUserId: 2,
    proDmsUserUnitId: 1,
    district: 59,
    unitNo: "1234",
  },
  {
    qmsUserId: 3,
    divisionId: 1,
    userRole: {
      value: 2,
      name: "QMS_QMR",
      displayName: "QMR",
      description: "Quality Management Representative (Subdivision)",
    },
    firstName: "I.M.",
    middleInitial: "",
    lastName: "Engineer",
    fullName: "I.M. Engineer",
    employeeNo: "s123456",
    email: "",
    phoneNumber: "",
    proDmsUserId: 3,
    proDmsUserUnitId: 1,
    district: 59,
    unitNo: "1234",
  },
];

const logError = (e) => console.error("ProDMS/QMS: Request failed with error:", e);

const qmsUserActions = {
  add: (newQmsUserData) => async (dispatch) => {
    dispatch({ type: QMS.USER.ADD });
    const apiEndpoint = BASE_URL + "/api/qms/QmsUser";
    try {
      const res = await axios.post(apiEndpoint, newQmsUserData);
      dispatch({ type: QMS.USER.ADD_FULFILLED });
      return res.data;
    } catch (e) {
      dispatch({ type: QMS.USER.ADD_REJECTED });
      raiseError(QMS.USER.ADD_REJECTED, e.response?.data);
      logError(e);
    }
  },
  addAll: (newQmsUsers) => async (dispatch) => {
    dispatch({ type: QMS.USER.ADD });
    const apiEndpoint = BASE_URL + "/api/qms/QmsUser/All";
    try {
      console.log("adding new qmsUsers=", newQmsUsers);
      const res = await axios.post(apiEndpoint, newQmsUsers);
      dispatch({ type: QMS.USER.ADD_FULFILLED });
      return res.data;
    } catch (e) {
      dispatch({ type: QMS.USER.ADD_REJECTED });
      logError(e);
    }
  },
  update: (qmsUserData) => async (dispatch) => {
    dispatch({ type: QMS.USER.UPDATE });
    const apiEndpoint = BASE_URL + "/api/qms/QmsUser";
    try {
      console.log(qmsUserData);
      const res = await axios.put(apiEndpoint, qmsUserData);
      dispatch({ type: QMS.USER.UPDATE_FULFILLED });
    } catch (e) {
      dispatch({ type: QMS.USER.UPDATE_REJECTED });
      logError(e);
    }
  },
  remove: (qmsUserId) => async (dispatch) => {
    dispatch({ type: QMS.USER.REMOVE });
    const apiEndpoint = BASE_URL + "/api/qms/QmsUser/" + qmsUserId;
    try {
      const res = await axios.delete(apiEndpoint);
      dispatch({
        type: QMS.USER.REMOVE_FULFILLED,
        qmsUsers: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.USER.REMOVE_REJECTED });
      logError(e);
    }
  },
  get: (qmsUserId) => async (dispatch) => {
    dispatch({ type: QMS.USER.FETCH });
    const apiEndpoint = BASE_URL + "/api/qms/QmsUser/" + qmsUserId;
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({ type: QMS.USER.FETCH_FULFILLED, qmsUser: res.data });
    } catch (e) {
      dispatch({ type: QMS.USER.FETCH_REJECTED });
      logError(e);
    }
  },
  getAll: () => async (dispatch) => {
    dispatch({ type: QMS.USER.FETCH_ALL });
    const apiEndpoint = BASE_URL + "/api/qms/QmsUser/List/";
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({
        type: QMS.USER.FETCH_ALL_FULFILLED,
        qmsUsers: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.USER.FETCH_ALL_REJECTED });
      logError(e);
    }
  },
  getAllForIssueFake: (issueId) => async (dispatch) => {
    dispatch({ type: QMS.USER.FETCH_ALL_FOR_ISSUE });

    delay(865);
    dispatch({
      type: QMS.USER.FETCH_ALL_FOR_ISSUE_FULFILLED,
      issueId,
      qmsUsers: fakeQmsUsers,
    });
  },
  getAllForIssue: (issueId) => async (dispatch) => {
    dispatch({ type: QMS.USER.FETCH_ALL_FOR_ISSUE });
    const apiEndpoint = BASE_URL + "/api/qms/QmsUser/ForIssue/" + issueId;
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({
        type: QMS.USER.FETCH_ALL_FOR_ISSUE_FULFILLED,
        issueId,
        qmsUsers: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.USER.FETCH_ALL_REJECTED });
      logError(e);
    }
  },
  /**
   * Get QmsUser by ProDmsUserId.
   * @param {number} proDmsUserId
   * @param {Boolean} updateClient - true if the fetched data should update user data in redux store.
   * @returns
   */
  getByProDmsUserId:
    (proDmsUserId, updateClient = false) =>
    async (dispatch) => {
      dispatch({ type: QMS.GENERIC_REQUEST });
      const apiEndpoint = BASE_URL + "/api/qms/QmsUser/ByProDmsUserId/" + proDmsUserId;
      try {
        // Returned result is null if no qmsUser with matching proDmsUserId was found.
        const res = await axios.get(apiEndpoint);
        dispatch({ type: QMS.GENERIC_REQUEST_FULFILLED });
        if (res.data && updateClient) {
          dispatch({ type: QMS.USER.UPDATE_CLIENT, qmsUser: res.data });
        }

        return res.data || null;
      } catch (e) {
        dispatch({ type: QMS.GENERIC_REQUEST_REJECTED });
        logError(e);
        return null;
      }
    },
  getUserRoles: () => async (dispatch) => {
    dispatch({ type: QMS.USER.FETCH_ROLES });
    const apiEndpoint = BASE_URL + "/api/qms/UserRole";
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({ type: QMS.USER.FETCH_ROLES_FULFILLED, userRoles: res.data });
    } catch (e) {
      dispatch({ type: QMS.GENERIC_REQUEST_REJECTED });
      logError(e);
      return null;
    }
  },
  getUserFunctionalRoles: (divisionId) => async (dispatch) => {
    dispatch({ type: QMS.USER.FETCH_FUNCTIONAL_ROLES });
    const apiEndpoint = BASE_URL + "/api/qms/UserFunctionalRole/" + divisionId;
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({
        type: QMS.USER.FETCH_FUNCTIONAL_ROLES_FULFILLED,
        userFunctionalRoles: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.USER.FETCH_FUNCTIONAL_ROLES_REJECTED });
      logError(e);
      return null;
    }
  },
};

export default qmsUserActions;
